export const SITE_URL = 'https://risman.pro';
export const SITE_NAME = 'Risman';
export const SITE_NAME_FA = 'ریسمان';
export const DEFAULT_LANGUAGE = 'fa';
export const SUPPORTED_LANGUAGES = ['en', 'fa'];

export const ORGANIZATION = {
  name: 'Risman',
  legalName: 'Risman',
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  sameAs: [
    'https://t.me/risman_pro',
    'https://www.instagram.com/risman_pro/',
    'https://www.linkedin.com/company/rismanpro'
  ],
  contactPoint: {
    telephone: '+98-905-747-8419',
    contactType: 'customer support',
    availableLanguage: ['English', 'Persian']
  }
};

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const SEO_ROUTES = {
  home: '/',
  about: '/about',
  pricing: '/pricing'
};
